/*
Created-by: XtroEdge AI
Updated-by: XtroEdge AI
Last modified: 2026-10-29T14:30:00+05:00
Intent: One rule for "does this plan include the WhatsApp Campaign Companion": the admin's whatsapp_companion setting, never a guess.
*/

// Names older responses used before the admin plan form settled on whatsapp_companion.
const LEGACY_FLAGS = ['campaign_companion', 'companion_access', 'whatsapp_access', 'companion_features'];

/** A flag as the server may send it (true / 1 / "true"), or undefined when it is not there. */
function readFlag(value: any): boolean | undefined {
  if (value === true || value === 1 || value === 'true' || value === '1') return true;
  if (value === false || value === 0 || value === 'false' || value === '0') return false;
  return undefined;
}

/**
 * Whether a plan includes WhatsApp Campaign Companion, as the admin configured it.
 *
 * Takes a plan card or the purchased plan. On the purchased plan, `sub_plan` is the client's
 * own subscription, which the admin can override, so its setting wins over the plan's.
 * An explicit `false` is final. Nothing is inferred from the plan's name or price: a "Growth"
 * plan configured without the Companion used to show it, and the client got the module.
 */
export function hasCompanionAccess(data: any): boolean {
  if (!data || typeof data !== 'object') return false;
  const sources = [data.sub_plan, data];

  for (const source of sources) {
    const flag = readFlag(source?.whatsapp_companion);
    if (flag !== undefined) return flag;
  }
  return sources.some((source) => LEGACY_FLAGS.some((key) => readFlag(source?.[key]) === true));
}
